// extracted by mini-css-extract-plugin
export default {"imgdiv":"_24961d74aa _078ca85459","img":"f14b4dee43 _1dc33b4d53"};